// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-page-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 10;
}
.info-page-logo {
  font-family: 'Playfair Display', serif;
  font-size: 1.3rem;
  color: var(--burgundy);
  cursor: pointer;
  flex: 1 1;
}

.info-page-hero {
  background: linear-gradient(135deg, var(--burgundy) 0%, var(--purple) 100%);
  padding: 40px 24px;
  text-align: center;
  color: #fff;
}
.info-page-hero h1 {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.4rem, 4vw, 2rem);
  margin: 0 0 8px;
}
.info-page-hero p {
  margin: 0;
  opacity: 0.85;
  font-size: 0.95rem;
}

.info-quick-nav {
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 16px 20px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  scrollbar-width: none;
}
.info-quick-nav::-webkit-scrollbar { display: none; }
.info-quick-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 14px;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 12px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 0.78rem;
  color: var(--text-secondary);
  transition: all 0.2s;
  min-width: 72px;
}
.info-quick-btn span:first-child { font-size: 1.3rem; }
.info-quick-btn:hover, .info-quick-btn.active {
  background: var(--burgundy);
  color: #fff;
  border-color: var(--burgundy);
}

.info-sections {
  max-width: 780px;
  margin: 0 auto;
  padding: 24px 16px 60px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-section-block {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  transition: box-shadow 0.3s;
  scroll-margin-top: 80px;
}
.info-section-block.highlighted {
  border-color: var(--burgundy);
  box-shadow: 0 0 0 3px rgba(128, 0, 32, 0.12);
}

.info-sec-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  background: linear-gradient(135deg, var(--burgundy), var(--purple));
  color: #fff;
}
.info-sec-icon { font-size: 1.6rem; }
.info-sec-header h2 {
  font-family: 'Playfair Display', serif;
  font-size: 1.15rem;
  margin: 0;
}

.info-sec-content {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.info-content-item h3 {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--burgundy);
  margin: 0 0 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.info-content-item p {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/InformationPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,2EAA2E;EAC3E,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,qBAAqB;AACvB;AACA,qCAAqC,aAAa,EAAE;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;AACjB;AACA,mCAAmC,iBAAiB,EAAE;AACtD;EACE,2BAA2B;EAC3B,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mEAAmE;EACnE,WAAW;AACb;AACA,iBAAiB,iBAAiB,EAAE;AACpC;EACE,sCAAsC;EACtC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB","sourcesContent":[".info-page-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n.info-page-logo {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.3rem;\n  color: var(--burgundy);\n  cursor: pointer;\n  flex: 1;\n}\n\n.info-page-hero {\n  background: linear-gradient(135deg, var(--burgundy) 0%, var(--purple) 100%);\n  padding: 40px 24px;\n  text-align: center;\n  color: #fff;\n}\n.info-page-hero h1 {\n  font-family: 'Playfair Display', serif;\n  font-size: clamp(1.4rem, 4vw, 2rem);\n  margin: 0 0 8px;\n}\n.info-page-hero p {\n  margin: 0;\n  opacity: 0.85;\n  font-size: 0.95rem;\n}\n\n.info-quick-nav {\n  display: flex;\n  overflow-x: auto;\n  gap: 10px;\n  padding: 16px 20px;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border);\n  scrollbar-width: none;\n}\n.info-quick-nav::-webkit-scrollbar { display: none; }\n.info-quick-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 10px 14px;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  transition: all 0.2s;\n  min-width: 72px;\n}\n.info-quick-btn span:first-child { font-size: 1.3rem; }\n.info-quick-btn:hover, .info-quick-btn.active {\n  background: var(--burgundy);\n  color: #fff;\n  border-color: var(--burgundy);\n}\n\n.info-sections {\n  max-width: 780px;\n  margin: 0 auto;\n  padding: 24px 16px 60px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.info-section-block {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  overflow: hidden;\n  transition: box-shadow 0.3s;\n  scroll-margin-top: 80px;\n}\n.info-section-block.highlighted {\n  border-color: var(--burgundy);\n  box-shadow: 0 0 0 3px rgba(128, 0, 32, 0.12);\n}\n\n.info-sec-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 20px;\n  background: linear-gradient(135deg, var(--burgundy), var(--purple));\n  color: #fff;\n}\n.info-sec-icon { font-size: 1.6rem; }\n.info-sec-header h2 {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.15rem;\n  margin: 0;\n}\n\n.info-sec-content {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.info-content-item h3 {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--burgundy);\n  margin: 0 0 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.info-content-item p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
